module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page page-payment container is-fluid"
  }, [_c('div', {
    staticClass: "container container-inner"
  }, [_c('div', {
    staticClass: "columns is-gapless is-multiline"
  }, [(_vm.dataPayment) ? _c('div', {
    staticClass: "column content content-main is-right",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true",
      "data-aos-delay": "300"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n          " + _vm._s(_vm.dataPayment.title) + "\n        ")]), _vm._v(" "), (_vm.dataPayment.content) ? _c('markdown', {
    staticStyle: {
      "margin-top": "45px"
    },
    attrs: {
      "source": _vm.dataPayment.content
    }
  }) : _vm._e()], 1) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ba8b4ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/payment.vue
// module id = 979
// module chunks = 1